const Config = {};

const domain = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
//const devDomain = "https://falcon.murphycc.com"

Config.url = domain;
Config.cookieName = "vertx-web.session";
Config.client = "DHL";

module.exports = { Config };
